var React = require('react');

function IconFaq3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.11198 21.5111H25.8898M8.11198 28.1778H25.8898M8.11198 34.3333H19.2231M31.2542 8.58667L24.9698 2.30222C24.1364 1.46889 23.0053 1 21.8275 1H5.88976C3.4342 1 1.44531 2.98889 1.44531 5.44444V36.5556C1.44531 39.0111 3.4342 41 5.88976 41H28.112C30.5675 41 32.5564 39.0111 32.5564 36.5556V11.7289C32.5564 10.5511 32.0875 9.42 31.2542 8.58667ZM8.11198 12.6689V9.33111C8.11198 8.41111 8.85642 7.66667 9.77642 7.66667H13.1142C14.0342 7.66667 14.7786 8.41111 14.7786 9.33111V12.6689C14.7786 13.5889 14.0342 14.3333 13.1142 14.3333H9.77642C8.85642 14.3333 8.11198 13.5889 8.11198 12.6689Z","stroke":"#ffffff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconFaq3.defaultProps = {"viewBox":"0 0 34 42","fill":"none"};

module.exports = IconFaq3;

IconFaq3.default = IconFaq3;
